import { DateTime } from "luxon";
const createJBPayload = async (
  eventData: any,
  allBiddersData: any,
  primaryBidderIndex: any,
  isOverwrite: any = false,
  kycMode: string = "online"
) => {
  console.log("eventData: ", eventData);
  const getPrimaryBidderPayload = () => {
    console.log("primaryBidderIndex: ", primaryBidderIndex);
    let payload: any = {};
    payload["status"] = "pending";

    payload["email"] = allBiddersData[primaryBidderIndex]?.email;
    payload["name"] = allBiddersData[primaryBidderIndex]?.name;
    payload["pan"] = allBiddersData[primaryBidderIndex]?.pan;
    payload["aadhar_number"] =
      allBiddersData[primaryBidderIndex]?.aadhar_number;
    payload["mobile_number"] =
      allBiddersData[primaryBidderIndex]?.mobile_number;
    payload["user_type"] = allBiddersData[primaryBidderIndex]?.user_type;
    payload["meta"] = {
      bid_application_flow_mode: kycMode === "offline" ? "offline" : "online",
      banker_email: eventData?.meta?.approver?.[0]?.email,
      enable_offline_payment_validation:
        eventData?.data?.meta?.enable_offline_payment_validation || false,
      bank_name: eventData?.meta?.bank_name,
      user_details: {
        address: null,
        mobile_number: payload["mobile_number"],
        aadhar_number: payload["aadhar_number"],
        user_type: payload["user_type"],
      },
      approver_email:
        eventData?.meta?.approver && eventData?.meta?.approver.length > 0
          ? eventData?.meta?.approver[0]?.email
          : "",
      approver_name:
        eventData?.meta?.approver && eventData?.meta?.approver.length > 0
          ? eventData?.meta?.approver[0]?.name
            ? eventData?.meta?.approver[0]?.name
            : eventData?.meta?.approver[0]?.email
          : "",
      branch_name: eventData?.meta?.branch_name,
      branch_uuid: eventData?.branch_uuid,
      event_name: eventData?.event_name,
      dashboard_url: `${window.location.origin}/auction-events`,
      event_id: eventData.listing_id,
      auction_start_datetime: DateTime.fromISO(eventData?.start_date_time)
        .setZone("Asia/Kolkata")
        .toFormat("dd MMMM yyyy hh:mm a"),
      emd_last_datetime: DateTime.fromISO(
        eventData?.property_dump?.emd_last_date
      )
        .setZone("Asia/Kolkata")
        .toFormat("dd MMMM yyyy hh:mm a"),
      name: payload.name,
      pan: payload.pan,
      reserve_price: eventData?.reserve_price,
      bidding_type: eventData?.bidding_type,
      emd_amount: eventData?.property_dump?.emd_amount,
      borrower_name: eventData?.borrower_name,
    };
    payload["is_joint"] = true;
    if (isOverwrite) {
      payload["is_overridden"] = true;
    }

    payload["access_type"] = "primary";
    payload["created_by"] = "user";
    payload["event_uuid"] = eventData?.uuid;

    return payload;
  };

  const getSecondaryBiddersPayload = () => {
    const secondaryBiddersData = [];
    console.log("primaryBidderIndex:2 ", primaryBidderIndex);
    const secondary = allBiddersData
      .filter((_: any, idx: any) => idx !== primaryBidderIndex)
      .filter(Boolean);
    console.log("secondary: ", secondary);

    for (let i = 0; i < secondary.length; i++) {
      let payload: any = {};

      payload["status"] = "pending";
      payload["email"] = secondary[i]?.email;
      payload["name"] = secondary[i]?.name;
      payload["pan"] = secondary[i]?.pan;
      payload["aadhar_number"] = secondary[i]?.aadhar_number;
      payload["mobile_number"] = secondary[i]?.mobile_number;
      payload["user_type"] = secondary[i]?.user_type;
      payload["meta"] = {
        bid_application_flow_mode: kycMode === "offline" ? "offline" : "online",
        banker_email: eventData?.meta?.approver?.[0]?.email,
        enable_offline_payment_validation:
          eventData?.data?.meta?.enable_offline_payment_validation || false,
        bank_name: eventData?.meta?.bank_name,
        user_details: {
          address: null,
          mobile_number: payload["mobile_number"],
          aadhar_number: payload["aadhar_number"],
          user_type: payload["user_type"],
        },
        approver_email:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.email
            : "",
        approver_name:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.name
              ? eventData?.meta?.approver[0]?.name
              : eventData?.meta?.approver[0]?.email
            : "",
        branch_name: eventData?.meta?.branch_name,
        event_name: eventData?.event_name,
        dashboard_url: `${window.location.origin}/auction-events`,
        event_id: eventData.listing_id,
        auction_start_datetime: DateTime.fromISO(eventData?.start_date_time)
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        emd_last_datetime: DateTime.fromISO(
          eventData?.property_dump?.emd_last_date
        )
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        name: payload.name,
        pan: payload.pan,
        reserve_price: eventData?.reserve_price,
        bidding_type: eventData?.bidding_type,
        emd_amount: eventData?.property_dump?.emd_amount,
        borrower_name: eventData?.borrower_name,
      };
      payload["is_joint"] = true;
      if (isOverwrite) {
        payload["is_overridden"] = true;
      }
      payload["access_type"] = "viewer";
      payload["created_by"] = "user";
      payload["event_uuid"] = eventData?.uuid;
      secondaryBiddersData.push(payload);
    }
    console.log("secondaryBiddersData: ", secondaryBiddersData);
    return secondaryBiddersData;
  };
  // console.log("d------->>", getPrimaryBidderPayload());
  // console.log("d2------->>", formatBidderNames(), getSecondaryBiddersPayload());

  const secondaryBiddersPayload = getSecondaryBiddersPayload();
  console.log("secondaryBiddersPayload: ", secondaryBiddersPayload);

  return {
    ...getPrimaryBidderPayload(),
    joint_bidders_payload: secondaryBiddersPayload,
  };
};

export default createJBPayload;
